// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DocumentsList_wrapper__9As42","itemWrapper":"DocumentsList_itemWrapper__gUwZg","iconWrapper":"DocumentsList_iconWrapper__5yhft"};